import { TFunction } from 'react-i18next';
import { CONFIGURATIONS_FORM_FIELDS, CONFIGURATIONS_FORM_FIELDS_NAMES } from './configurations-form';

interface IConfigurationProps {
	t: TFunction;
}

export const CONFIGURATION_FIELDS = ({ t }: IConfigurationProps): ConfigurationType[] => [
	// {
	// 	items: [
	// 		{
	// 			title: t(CONFIGURATIONS_FORM_FIELDS_NAMES.GHOST_PERCENTAGE),
	// 			description: t(CONFIGURATIONS_FORM_FIELDS_NAMES.GHOST_PERCENTAGE_DESCRIPTION),
	// 			input: {
	// 				key: CONFIGURATIONS_FORM_FIELDS.GHOST_PERCENTAGE,
	// 				fieldName: CONFIGURATIONS_FORM_FIELDS.GHOST_PERCENTAGE,
	// 				percentage: true,
	// 				firstField: true,
	// 			}
	// 		}
	// 	]
	// },
	{
		items: [
			{
				title: t(CONFIGURATIONS_FORM_FIELDS_NAMES.THROTTLE_PERCENTAGE),
				description: t(CONFIGURATIONS_FORM_FIELDS_NAMES.THROTTLE_PERCENTAGE_DESCRIPTION),
				input: {
					key: CONFIGURATIONS_FORM_FIELDS.THROTTLE_PERCENTAGE,
					fieldName: CONFIGURATIONS_FORM_FIELDS.THROTTLE_PERCENTAGE,
					percentage: true,
					firstField: true,
				}
			}
		]
	},
	{
		items: [
			{
				title: t(CONFIGURATIONS_FORM_FIELDS_NAMES.MAX_PER_DAY),
				description: t(CONFIGURATIONS_FORM_FIELDS_NAMES.MAX_PER_DAY_DESCRIPTION),
				input: {
					key: CONFIGURATIONS_FORM_FIELDS.MAX_PER_DAY,
					fieldName: CONFIGURATIONS_FORM_FIELDS.MAX_PER_DAY,
					firstField: true,
				}
			}
		]
	},
	{
		items: [
			{
				title: t(CONFIGURATIONS_FORM_FIELDS_NAMES.LIMIT_COUNT),
				description: t(CONFIGURATIONS_FORM_FIELDS_NAMES.LIMIT_COUNT_DESCRIPTION),
				input: {
					key: CONFIGURATIONS_FORM_FIELDS.LIMIT_COUNT,
					fieldName: CONFIGURATIONS_FORM_FIELDS.LIMIT_COUNT,
					firstField: true,
				}
			},
			{
				title: t(CONFIGURATIONS_FORM_FIELDS_NAMES.PER),
				input: {
					key: CONFIGURATIONS_FORM_FIELDS.LIMIT_INTERVAL,
					fieldName: CONFIGURATIONS_FORM_FIELDS.LIMIT_INTERVAL,
					firstField: false,
				}
			},
			{
				title: t(CONFIGURATIONS_FORM_FIELDS_NAMES.LIMIT_INTERVAL),
				input: null
			},

		],
	},
	{
		items: [
			{
				title: t(CONFIGURATIONS_FORM_FIELDS_NAMES.MAXIMUM_ORDERS),
				description: t(CONFIGURATIONS_FORM_FIELDS_NAMES.MAXIMUM_ORDERS_DESCRIPTION),
				input: {
					key: CONFIGURATIONS_FORM_FIELDS.MAXIMUM_ORDERS,
					fieldName: CONFIGURATIONS_FORM_FIELDS.MAXIMUM_ORDERS,
					symbolCode: true,
					firstField: true,
				}
			}
		]
	},
	// {
	// 	items: [
	// 		{
	// 			title: t(CONFIGURATIONS_FORM_FIELDS_NAMES.NFS_DECLINE_THROTTLING),
	// 			description: t(CONFIGURATIONS_FORM_FIELDS_NAMES.NFS_DECLINE_THROTTLING_DESCRIPTION),
	// 			input: {
	// 				key: CONFIGURATIONS_FORM_FIELDS.NFS_DECLINE_THROTTLING,
	// 				fieldName: CONFIGURATIONS_FORM_FIELDS.NFS_DECLINE_THROTTLING,
	// 				percentage: true,
	// 				firstField: true,
	// 			}
	// 		}
	// 	]
	// },
	{
		items: [
			{
				title: t(CONFIGURATIONS_FORM_FIELDS_NAMES.AGREED_EXPIRY_DATE_MIT),
				description: t(CONFIGURATIONS_FORM_FIELDS_NAMES.AGREED_EXPIRY_DATE_MIT_DESCRIPTION),
				input: {
					key: CONFIGURATIONS_FORM_FIELDS.AGREED_EXPIRY_DATE_MIT,
					fieldName: CONFIGURATIONS_FORM_FIELDS.AGREED_EXPIRY_DATE_MIT,
					// percentage: true,
					firstField: true,
				}
			}
		]
	},
	{
		items: [
			{
				title: t(CONFIGURATIONS_FORM_FIELDS_NAMES.MIN_ORDER_AMOUNT),
				description: t(CONFIGURATIONS_FORM_FIELDS_NAMES.MIN_ORDER_AMOUNT_DESCRIPTION),
				input: {
					key: CONFIGURATIONS_FORM_FIELDS.MIN_ORDER_AMOUNT,
					fieldName: CONFIGURATIONS_FORM_FIELDS.MIN_ORDER_AMOUNT,
					symbolCode: true,
					firstField: true,
				}
			}
		]
	},
	{
		items: [
			{
				title: t(CONFIGURATIONS_FORM_FIELDS_NAMES.MAX_ORDER_AMOUNT),
				description: t(CONFIGURATIONS_FORM_FIELDS_NAMES.MAX_ORDER_AMOUNT_DESCRIPTION),
				input: {
					key: CONFIGURATIONS_FORM_FIELDS.MAX_ORDER_AMOUNT,
					fieldName: CONFIGURATIONS_FORM_FIELDS.MAX_ORDER_AMOUNT,
					symbolCode: true,
					firstField: true,
				}
			}
		]
	},
	// {
	// 	items: [
	// 		{
	// 			title: t(CONFIGURATIONS_FORM_FIELDS_NAMES.DYNAMIC_AUTHORIZATION_DISCOUNT_THROTTLE_PERCENTAGE),
	// 			description: t(CONFIGURATIONS_FORM_FIELDS_NAMES.DYNAMIC_AUTHORIZATION_DISCOUNT_THROTTLE_PERCENTAGE),
	// 			input: {
	// 				key: CONFIGURATIONS_FORM_FIELDS.DYNAMIC_AUTHORIZATION_DISCOUNT_THROTTLE_PERCENTAGE,
	// 				fieldName: CONFIGURATIONS_FORM_FIELDS.DYNAMIC_AUTHORIZATION_DISCOUNT_THROTTLE_PERCENTAGE,
	// 				percentage: true,
	// 				firstField: true,
	// 			}
	// 		}
	// 	]
	// },
];


type InputType = {
	key: CONFIGURATIONS_FORM_FIELDS,
	fieldName: CONFIGURATIONS_FORM_FIELDS,
	percentage?: boolean,
	symbolCode?: boolean,
	firstField: boolean,
}

type ItemType = {
	title: string;
	input: InputType | null;
	description?: string;
}

type ConfigurationType = {
	items: ItemType[]
}
